import React from 'react'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'

class TasteAdviceList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            filters: {},
            tasteAdvices: {
                columns: [
                    {
                        label: 'Taste advice name in English',
                        key: 'nameEn'
                    },
                    {
                        label: 'Taste advice name in Chinese',
                        key: 'nameZh'
                    },
                    {
                        content: 'Edit',
                        action: 'edit',
                        className: 'edit-link',
                        onClick: (id, key) => {
                            this.props.history.push('/taste-advices/' + id + '/edit')
                        }
                    }],
                entities: [],
                filters: [],
                actions: [{
                    classList: 'blue add',
                    label: 'New taste advice',
                    onClick: () => this.props.history.push('/taste-advices/new')
                }],
                selectedItems: [],
                multiSelect: false,
            }
        }
    }

    componentDidMount() {
        API.getTasteAdvices(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                tasteAdvices: {...this.state.tasteAdvices, entities: entities}
            })
        })
    }

    loadEntities() {
        API.getTasteAdvices(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                tasteAdvices: {...this.state.tasteAdvices, entities: entities}
            })
        })
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'Taste Advices'}/>
                <Content>
                    <Table settings={this.state.tasteAdvices}/>
                </Content>
            </>
    }
}

export default TasteAdviceList
